var map = {
	"./01_Referenz_5w-50-min.webp": 60,
	"./01_Referenz_5w-50_mobile-min.webp": 61,
	"./02_Referenz_5w-50-min.webp": 62,
	"./02_Referenz_5w-50_mobile-min.webp": 63,
	"./03_Referenz_5w-50-min.webp": 64,
	"./03_Referenz_5w-50_mobile-min.webp": 65,
	"./5W-50-logo-white-min.webp": 28,
	"./ihr_autohaus-min.webp": 66,
	"./laptop-small-min.webp": 27,
	"./logo-googlePartner-min.webp": 30,
	"./logo-provenExpert-min.webp": 29,
	"./olaf_1920-min.webp": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;